module.exports = __webpack_public_path__ + "static/media/noimage.1de31242.gif";